import React, {useState} from "react";
import "./index.css";
import cn from "classnames";
import Textarea from "../../../layout/Textarea/Textarea";
import ImageUpload from "../../../layout/ImageUpload";
import {UI, newsletterLayoutTypes} from "../../../data/constants";
import {checkIfIDE} from "../../../data/products/index";
import Icon from "../../../layout/Icon";
import BgTransformer from "../../../layout/BgTransformer";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {useLogoUrl} from "../../../hooks/useLogoUrl";

const SoMeVerticalPartners = ({id, zoom}) => {
  const {product, layoutOption, iconOption, locked, visible, type} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, subtitles, dates} = useEdits();
  const logoURL = useLogoUrl(id);
  const title = titles[id] || titles.main;
  const [showProductName, setShowProductName] = useState(true);
  const date = dates[id] || dates.main;
  const subtitle = subtitles[id] || subtitles.main;
  const iconUrl = `${UI}/Icons/${iconOption}.svg`;
  const isNewsletter = newsletterLayoutTypes.includes(type.value);
  const newsletterClass = isNewsletter ? "newsletter" : "";
  const templateClass = cn("template", `layout-${layoutOption}`, newsletterClass);
  const contentClass = cn("content", `layout-${layoutOption}`);
  const uploadClass = cn("upload-wrap", `layout-${layoutOption}`);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value)});
  const isLocked = locked.some((elem) => elem === id);
  const isVisible = visible.some((elem) => elem === id);

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <BgTransformer src={bgUrl} id={id} />

          <div className="content">
            <header className="template-header">
              <div className={logoClass}>
                <img src={logoURL} alt="background" />
              </div>
              <div className="upload-wrap">
                <ImageUpload id={id} />
              </div>
            </header>

            <div className="title-wrap">
              <h1 className="title">
                <Textarea id={id} text={title} />
              </h1>
              {[3, 4].includes(layoutOption) && (
                <h2 className="subtitle">
                  <Textarea id={id} text={subtitle} />
                </h2>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SoMeVerticalPartners;
